import React, { createContext } from 'react'
import feathers from '@feathersjs/feathers'
import rest from '@feathersjs/rest-client'
import auth from '@feathersjs/authentication-client'

export const app = feathers()

const restClient = rest(
  process.env.REACT_APP_API_URL || 'http://localhost:3000',
).fetch(window.fetch)

export const talentTokenKey = 'talent_token'

app.configure(restClient)
app.configure(
  auth({
    storage: window.localStorage,
    storageKey: talentTokenKey,
  }),
)

const addJWT =
  (options = {}) =>
  async (context) => {
    const token = localStorage.getItem(talentTokenKey)

    if (token) {
      context.params.headers = {
        ...context.params.headers,
        Authorization: `Bearer ${token}`,
      }
    }

    return context
  }

app.hooks({
  before: {
    all: [addJWT()],
  },
})

export const FeathersContext = createContext(null)

// eslint-disable-next-line import/prefer-default-export
export const FeathersProvider = ({ children }) => (
  <FeathersContext.Provider value={app}>{children}</FeathersContext.Provider>
)
